import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { UserRound } from "lucide-react";
import { Req, SectionHeader, AUTO_INPUT_CLS, FieldError, invalidCls } from "@/components/newTicket/parts";

export default function CustomerInfoSection({ form, setForm, ownerName, validation = {} }) {
  const nameErr = validation.err?.("customer_name");
  return (
    <section data-testid="section-customer-info">
      <SectionHeader letter="B" title="Customer Information" icon={UserRound} />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-5 gap-y-4">
        <div>
          <Label className="text-xs font-semibold text-slate-700">Customer Name<Req /></Label>
          <Input
            data-testid="customer-name-input"
            className={`mt-1.5 h-10 ${invalidCls(nameErr)}`}
            placeholder="Full name"
            value={form.customer_name}
            onBlur={() => validation.touch?.("customer_name")}
            onChange={(e) => setForm({ ...form, customer_name: e.target.value })}
          />
          <FieldError name="customer_name" msg={nameErr} />
        </div>
        <div>
          <Label className="text-xs font-semibold text-slate-700">Email Address</Label>
          <Input
            data-testid="email-input"
            type="email"
            className="mt-1.5 h-10"
            placeholder="customer@email.com"
            value={form.email_address}
            onChange={(e) => setForm({ ...form, email_address: e.target.value })}
          />
        </div>
        <div>
          <Label className="text-xs font-semibold text-slate-700">Alternate Number</Label>
          <Input
            data-testid="alternate-number-input"
            className="mt-1.5 h-10 font-mono"
            placeholder="Optional"
            value={form.alternate_number}
            onChange={(e) => setForm({ ...form, alternate_number: e.target.value })}
          />
        </div>
        <div>
          <Label className="text-xs font-semibold text-slate-700">Owner <span className="text-slate-400 font-normal">(auto)</span></Label>
          <Input
            data-testid="owner-input"
            readOnly
            className={`mt-1.5 h-10 ${AUTO_INPUT_CLS}`}
            value={ownerName || ""}
          />
        </div>
      </div>
    </section>
  );
}
